import { QueryFunction } from 'react-query';
import { AppDataQueryKey, queryClient } from '@/lib/query-client';
import { getPartner } from '@/lib/services/partner.service';

export { AppDataQueryKey };

// const HOUR = 1000 * 60 * 60;

type QueryOptions = { cacheTime: number; staleTime: number };

export const AppDataQueries: Map<
  AppDataQueryKey,
  { queryFn: QueryFunction; options: QueryOptions }
> = new Map();

AppDataQueries.set(AppDataQueryKey.PartnerBasicInfo, {
  queryFn: getPartner,
  options: { cacheTime: 0, staleTime: 4000 },
});

export const prefetchAppData = async () => {
  const prefetchQueries: Promise<void>[] = [];

  for (const [queryKey, { queryFn, options }] of AppDataQueries) {
    prefetchQueries.push(queryClient.prefetchQuery(queryKey, queryFn, options));
  }

  if (!prefetchQueries.length) {
    return;
  }

  return Promise.all(prefetchQueries);
};
